/**
 配置管理--设备快速查询--订单信息--充电数据--图表；
 在线运维--订单列表/非直连订单--充电数据--图表
 */
import React, { Component } from "react";
import { orderHisNew, getUnDirectChargeInfo } from "@/fetch/fetchApi";
import "../../../assets/stylus/com/display/process.styl";
import G2 from "@antv/g2";
import collect from "collect.js";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@connect((state) => state)
class StubChargeCourse extends Component {
  constructor(props) {
    super(props);
    this.init();
    this.props = props;
    this.internationalization = this.props.intl.messages.stubChargeCourse;
    this.state = {
      currentPhase: "stub",
    };
  }

  init() {
    this.query = {
      page: "1",
      pagecount: "10",
    };
    console.log("init:", this, this.props, this.props.params);
    this.query["orderId"] = this.props.params["orderId"];
    // this.query["orderId"] = "202511201007531545"
  }

  translateTime = (e) => {
    // debugger;
    const time = e;
    const newTime = new Date(parseInt(time));
    const hours = newTime.getHours() < 10 ? `0${newTime.getHours()}` : newTime.getHours();
    const minutes = newTime.getMinutes() < 10 ? `0${newTime.getMinutes()}` : newTime.getMinutes();
    const seconds = newTime.getSeconds() < 10 ? `0${newTime.getSeconds()}` : newTime.getSeconds();
    return `${hours}:${minutes}:${seconds}`;
  };

  componentDidMount() {
    if (window.LayoutTab) {
      setTimeout(() => {
        this.queryChargeInfo();
      }, 1);
    }
  }

  queryChargeInfo() {
    // 桩端数据
    this.getProcessData(this.query["orderId"]).then((data) => {
      console.log("queryChargeInfo:", data);
      this.generateProcessData(data);
    });
  }

  async getProcessData(id) {
    let resData;
    try {
      if (
        this.props.panelsInfo.openPanels.find((v) => v.key === "chargeCoursechargeCourse").param[
          "isUnDirect"
        ]
      ) {
        resData = await getUnDirectChargeInfo({
          orderId: id,
        });
      } else {
        resData = await orderHisNew({
          orderId: id,
        });
      }
      console.log("getProcessData resData:", resData);
      // this.setState({
      //   tableData: resData.data,
      // });
      return resData.data;
    } catch (e) {
      console.debug(e);
    }
  }

  generateProcessData(data) {
    // 过程数据类型数组
    const processList = this.props.panelsInfo.openPanels.find(
      (v) => v.key === "chargeCoursechargeCourse",
    ).param["isUnDirect"]
      ? [
          {
            name: "voltage",
            nameStr: this.internationalization.title1, // '桩端输出电压',
          },
          {
            name: "electric",
            nameStr: this.internationalization.title3, // '桩端输出电流',
          },

          {
            name: "gunTemperature",
            secname: "deviceTemperature",
            nameStr: this.internationalization.title7, // '枪端温度',
            secnameStr: this.internationalization.title8, // '桩端温度',
          },
        ]
      : [
          {
            name: "voltage",
            secname: "voltageCar",
            nameStr: this.internationalization.title1, // '桩端输出电压',
            secnameStr: this.internationalization.title2, // '车端需求电压'
          },
          {
            name: "current",
            secname: "currentCar",
            nameStr: this.internationalization.title3, // '桩端输出电流',
            secnameStr: this.internationalization.title4, // '车端需求电流'
          },
          {
            name: "soc",
            nameStr: "soc",
          },
          {
            name: "power",
            nameStr: this.internationalization.title5, // '电量'
          },
          {
            name: "tempCar",
            secname: "tempGun",
            thrname: "tempStub",
            forthname: "enviroTemp",
            nameStr: this.internationalization.title6, // '电池温度',
            secnameStr: this.internationalization.title7, // '枪端温度',
            thrnameStr: this.internationalization.title8, // '桩端温度'
          },
          {
            name: "tempGun",
            nameStr: "枪温",
          },
          {
            name: "cpVoltage",
            nameStr: "CP电压",
          },
          {
            name: "gridFrequency",
            nameStr: "电网频率",
          },
          {
            name: "tempFireLine",
            nameStr: "火线温度",
          },
          {
            name: "tempRelay",
            nameStr: "继电器温度",
          },
        ];
    // debugger;
    if (data.code === "200") {
      let result = this.props.panelsInfo.openPanels.find(
        (v) => v.key === "chargeCoursechargeCourse",
      ).param["isUnDirect"]
        ? data.data
        : data.data.his;
      if (!result) {
        return;
      }
      result = result.reverse();
      console.log({ result });
      result.forEach((e) => {
        console.log({ e });
        for (const p of processList) {
          if (!p["arr"]) {
            p["arr"] = [];
          }
          const [pVal, pTime] = [
            e[p.name] ? parseFloat(e[p.name]) : 0,
            e.time ? this.translateTime(e.time) : e.reportTime,
          ];
          console.log(pVal);
          p["arr"].push({
            attr: p.nameStr,
            time: pTime,
            value: pVal < 0 ? 0 : pVal,
          });
          let secVal = 0;
          if (p.secname) {
            secVal = e[p.secname] ? parseFloat(e[p.secname]) : 0;
            p["arr"].push({
              attr: p.secnameStr,
              time: pTime,
              value: secVal < 0 ? 0 : secVal,
            });
          }
          let thrVal = 0;
          if (p.thrname) {
            thrVal = e[p.thrname] ? parseFloat(e[p.thrname]) : 0;
            p["arr"].push({
              attr: p.thrnameStr,
              time: pTime,
              value: thrVal < 0 ? 0 : thrVal,
            });
          }
        }
      });
      for (const process of processList) {
        const chart = new G2.Chart({
          // this.query['orderId'] +
          container: `${this.query["orderId"]}g2${process.name}`,
          width: 1420,
          height: 250,
          forceFit: true,
          padding: [30, 40, 36, 50],
        });
        chart.source(process.arr, {
          time: {
            tickCount: 5,
            range: [0, 1],
          },
        });

        // 建构纵向刻度范围
        // const ticks = [];
        console.debug("---------->>", process);
        process.limitMin = collect(process.arr).min("value");
        process.limitMax = collect(process.arr).max("value");
        // const [ticksLen, ticksDistance] = [
        //   process.limitMax - process.limitMin,
        //   ((process.limitMax - process.limitMin) / 4).toFixed(3),
        // ];
        // for (let i = 0, l = 5; i < l; i += 1) {
        //   if (ticksLen) {
        //     ticks.push(
        //       parseFloat(
        //         process.limitMin + parseFloat(i * ticksDistance),
        //       ).toFixed(2),
        //     );
        //   } else {
        //     ticks.push(parseFloat(process.limitMin + 50 * i).toFixed(2));
        //   }
        // }
        chart.scale("value", {
          min: process.limitMin,
          max: process.limitMax,
          nice: true,
        });
        chart.tooltip({
          crosshairs: {
            type: "line",
          },
        });
        chart.line().position("time*value").color("attr").shape("line");
        chart.render();
      }
    }
  }

  render() {
    const stubData = (
      <div style={{ padding: "20px" }}>
        <div className="g2item">
          <div className="g2label">{this.internationalization.title9}(V)</div>
          <div className="g2container" id={`${this.query["orderId"]}g2voltage`}></div>
        </div>
        {this.props.panelsInfo.openPanels.find((v) => v.key === "chargeCoursechargeCourse").param[
          "isUnDirect"
        ] ? (
          <div className="g2item">
            <div className="g2label">{this.internationalization.title10}(A)</div>
            <div className="g2container" id={`${this.query["orderId"]}g2electric`}></div>
          </div>
        ) : (
          <div className="g2item">
            <div className="g2label">{this.internationalization.title10}(A)</div>
            <div className="g2container" id={`${this.query["orderId"]}g2current`}></div>
          </div>
        )}
        {this.props.panelsInfo.openPanels.find((v) => v.key === "chargeCoursechargeCourse").param[
          "isUnDirect"
        ] ? null : (
          <div className="g2item">
            <div className="g2label">{this.internationalization.title11}(%)</div>
            <div className="g2container" id={`${this.query["orderId"]}g2soc`}></div>
          </div>
        )}
        {this.props.panelsInfo.openPanels.find((v) => v.key === "chargeCoursechargeCourse").param[
          "isUnDirect"
        ] ? null : (
          <div className="g2item">
            <div className="g2label">{this.internationalization.title12}(度)</div>
            <div className="g2container" id={`${this.query["orderId"]}g2power`}></div>
          </div>
        )}
        {this.props.panelsInfo.openPanels.find((v) => v.key === "chargeCoursechargeCourse").param[
          "isUnDirect"
        ] ? (
          <div className="g2item">
            <div className="g2label">{this.internationalization.title13}(℃)</div>
            <div className="g2container" id={`${this.query["orderId"]}g2gunTemperature`}></div>
          </div>
        ) : (
          <div className="g2item">
            <div className="g2label">{this.internationalization.title13}(℃)</div>
            <div className="g2container" id={`${this.query["orderId"]}g2tempCar`}></div>
          </div>
        )}
        {this.props.panelsInfo.openPanels.find((v) => v.key === "chargeCoursechargeCourse").param[
          "isUnDirect"
        ] ? null : (
          <div className="g2item">
            <div className="g2label">{this.internationalization.title14}(℃)</div>
            <div className="g2container" id={`${this.query["orderId"]}g2tempGun`}></div>
          </div>
        )}
        {this.props.panelsInfo.openPanels.find((v) => v.key === "chargeCoursechargeCourse").param[
          "isUnDirect"
        ] ? null : (
          <div className="g2item">
            <div className="g2label">{this.internationalization.title15}(V)</div>
            <div className="g2container" id={`${this.query["orderId"]}g2cpVoltage`}></div>
          </div>
        )}
        {this.props.panelsInfo.openPanels.find((v) => v.key === "chargeCoursechargeCourse").param[
          "isUnDirect"
        ] ? null : (
          <div className="g2item">
            <div className="g2label">{this.internationalization.title16}(Hz)</div>
            <div className="g2container" id={`${this.query["orderId"]}g2gridFrequency`}></div>
          </div>
        )}
        {this.props.panelsInfo.openPanels.find((v) => v.key === "chargeCoursechargeCourse").param[
          "isUnDirect"
        ] ? null : (
          <div className="g2item">
            <div className="g2label">{this.internationalization.title17}(℃)</div>
            <div className="g2container" id={`${this.query["orderId"]}g2tempFireLine`}></div>
          </div>
        )}
        {this.props.panelsInfo.openPanels.find((v) => v.key === "chargeCoursechargeCourse").param[
          "isUnDirect"
        ] ? null : (
          <div className="g2item">
            <div className="g2label">{this.internationalization.title18}(℃)</div>
            <div className="g2container" id={`${this.query["orderId"]}g2tempRelay`}></div>
          </div>
        )}
      </div>
    );

    return stubData;
  }
}

export default injectIntl(StubChargeCourse);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubChargeCourse.js